import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { accessAuthState } from '../states/auth.state';

interface PrivateRoute {
  path: string;
  exact?: boolean;
  showLogin?: boolean;
  component: any;
  roles?: any;
}

export const PrivateRoute = (props: PrivateRoute) => {
  const { component: Component, roles, showLogin, ...rest } = props

  return (
    <Route {...rest} render={props => {
      const authState = accessAuthState()

      if (!authState.isLoggedIn) {
        // not logged in so redirect to login page with the return url
        return <Redirect to={{ pathname: '/', search: `${showLogin ? '?action=login' : ''}`, state: { from: props.location } }} />
      }

      // check if route is restricted by role
      // role not authorised so redirect to home page
      // if (roles && roles.indexOf(currentUser.role) === -1) {
      //   return <Redirect to={{ pathname: '/' }} />
      // }

      // authorised so return component
      return <Component {...props} />
    }} />
  )
}
